import 'amfe-flexible';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Button, Toast, Field, Dialog, Cell, CellGroup, PullRefresh, NavBar } from 'vant'
import {initBridgeWebMethods} from '@/assets/js/jsbridge'

Vue.config.productionTip = false

void [Button, Toast, Field, Dialog, Cell, CellGroup, PullRefresh,NavBar ].forEach(element => {
  Vue.use(element)
});
initBridgeWebMethods();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
